<iconify [name]="'eos-icons:loading'" [size]="size" />
